import { FleekError } from './FleekError';

type IpnsRecordsNotFoundErrorOptions = Record<string, never>;

export class IpnsRecordsNotFoundError extends FleekError<IpnsRecordsNotFoundErrorOptions> {
  public name = 'IpnsRecordsNotFoundError';

  constructor() {
    super({});
  }

  toString = () => 'No IPNS records found.';
}
